// 官网路由配置
// 说明：采用 Vue Router 默认的 hash 模式（地址形如 /#/news），
//      部署到任意静态服务器都不用额外配置；如需 history 模式可在下方加 mode: 'history'。
import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/Home.vue'
import NewsList from '../views/NewsList.vue'
import NewsDetail from '../views/NewsDetail.vue'
import ProductList from '../views/ProductList.vue'
import ProductDetail from '../views/ProductDetail.vue'
import About from '../views/About.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/news', name: 'NewsList', component: NewsList },
  // 新闻详情：/news/123
  { path: '/news/:id', name: 'NewsDetail', component: NewsDetail },
  { path: '/products', name: 'ProductList', component: ProductList },
  // 产品详情：/products/123
  { path: '/products/:id', name: 'ProductDetail', component: ProductDetail },
  // 关于我们：内容来自后台「站点配置」
  { path: '/about', name: 'About', component: About },
  // 兜底：访问不存在的地址时回到首页
  { path: '*', redirect: '/' }
]

const router = new VueRouter({ routes })

export default router
